import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import axios from "axios"
import { toast } from "react-toastify"
import { baseUrl } from "../../config/baseUrl"

const initialFormState = {
    question: "",
    answer: "",
    questionHindi: "",
    answerHindi: "",
    sortOrder: 0,
    status: "active",
}

export default function FaqAdd() {
    const [formData, setFormData] = useState(initialFormState)
    const [submitting, setSubmitting] = useState(false)
    const navigate = useNavigate()
    const token = localStorage.getItem("token")

    const handleChange = (event) => {
        const { name, value } = event.target
        setFormData((prev) => ({
            ...prev,
            [name]: name === "sortOrder" ? value.replace(/[^\d-]/g, "") : value,
        }))
    }

    const handleSubmit = async (event) => {
        event.preventDefault()

        if (!formData.question.trim() || !formData.answer.trim()) {
            toast.error("English question and answer are required")
            return
        }

        setSubmitting(true)
        try {
            const response = await axios.post(`${baseUrl}/faq`, formData, {
                headers: {
                    Authorization: token,
                },
            })

            if (response?.data?.status) {
                toast.success("FAQ added successfully")
                navigate("/faqs")
                return
            }

            toast.error(response?.data?.message || "Failed to add FAQ")
        } catch (error) {
            console.error("Error creating FAQ:", error)
            toast.error(error?.response?.data?.message || "Failed to add FAQ")
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <section className="main-sec">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="dashboard-title">
                        <h4 className="dash-head">
                            <i className="fa fa-question-circle me-2" />
                            Add FAQ
                        </h4>
                    </div>
                    <div className="custom-bredcump">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/">Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/faqs">FAQs</Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Add FAQ
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div className="col-lg-6 d-flex justify-content-end">
                    <Link to="/faqs" className="btn btn-info text-white">
                        <i className="fa fa-arrow-left me-1"></i>
                        Back
                    </Link>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="cards edit-usr">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-6 mb-4">
                                    <label htmlFor="question" className="form-label">
                                        English Question<sup className="text-danger">*</sup>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="question"
                                        name="question"
                                        placeholder="Enter English question"
                                        value={formData.question}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-lg-6 mb-4">
                                    <label htmlFor="questionHindi" className="form-label">
                                        Hindi Question
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="questionHindi"
                                        name="questionHindi"
                                        placeholder="Enter Hindi question"
                                        value={formData.questionHindi}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-lg-6 mb-4">
                                    <label htmlFor="answer" className="form-label">
                                        English Answer<sup className="text-danger">*</sup>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows={6}
                                        id="answer"
                                        name="answer"
                                        placeholder="Enter English answer"
                                        value={formData.answer}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>

                                <div className="col-lg-6 mb-4">
                                    <label htmlFor="answerHindi" className="form-label">
                                        Hindi Answer
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows={6}
                                        id="answerHindi"
                                        name="answerHindi"
                                        placeholder="Enter Hindi answer"
                                        value={formData.answerHindi}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>

                                <div className="col-lg-6 mb-4">
                                    <label htmlFor="sortOrder" className="form-label">
                                        Sort Order
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="sortOrder"
                                        name="sortOrder"
                                        placeholder="0"
                                        value={formData.sortOrder}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-lg-6 mb-4">
                                    <label htmlFor="status" className="form-label">
                                        Status<sup className="text-danger">*</sup>
                                    </label>
                                    <select
                                        className="form-control"
                                        id="status"
                                        name="status"
                                        value={formData.status}
                                        onChange={handleChange}
                                    >
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>

                                <div className="col-lg-12 text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-add-question text-white"
                                        disabled={submitting}
                                    >
                                        <i className="fa fa-save me-1"></i>
                                        {submitting ? "Saving..." : "Save FAQ"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}
